import React from "react";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Core Features";

const CoreFeatures = () => (
  <div className="bg-navy-dark text-white text-lg font-light">
    <HeroSection className="sm:py-12 lg:py-20">
      <div className="md:w-2/3 xl:w-1/2 mx-auto">
        <HeroSection.Content className="md:text-center">
          <HeroSection.Header className="mt-0">
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
          <HeroSection.Description className="text-gray-100 mt-4">
            From door-to-door qualification through PTO, Enerflo guides you and your customers every step of the way,
            creating transparency and trust from day one. Learn more about the features that set our platform apart.
          </HeroSection.Description>
        </HeroSection.Content>
      </div>
    </HeroSection>
  </div>
);

export default CoreFeatures;
